export const bigDataLocationApiKey = process.env.MIX_BIGDATA_LOCATION_API_KEY

export const googleMapsApiKey =
(window.APP_CONFIG && window.APP_CONFIG.googleMapsApiKey) ||

''